import webApi, { baseURL } from "../../WebApi/WebApi";

//CO2 LIST

export const getFaqList = async (moduleType) => {
    return await webApi.post('/customer/common/faq-module-wise',{moduleType});
}

export const getCmsList = async (type) => {
    return await webApi.post('/customer/common/cms-type-wise',{type});
}


export const getCMSTeams = async ()=>{
    return await webApi.get(`/customer/common/cms-teams`);
}

export const getCMSPartners = async ()=>{
    return await webApi.get(`/customer/common/cms-partners`);
}

export const listService = async ()=>{
    return await webApi.get(`/customer/common/cms-service`)
}

export const listSolution = async ()=>{
    return await webApi.get(`/customer/common/cms-solution`)
}

